export const ExtendedAccessRoleName = "extended_access"

export enum ExtendedAccessStatus {
	Available = "available",
	/** @lintignore */
	Active = "active",
	/** @lintignore */
	Expired = "expired",
}

export type ExtendedAccess = {
	status: ExtendedAccessStatus
	endsAt: string | null
}
